<template>
  <div class="health-service-page">
    <!-- 背景图片 -->
    <img class="page-bg" :src="bgImage" alt="背景" />

    <!-- Logo -->
    <img class="page-logo" :src="logoImage" alt="Logo"/>

    <!-- 返回按钮 -->
    <img class="page-back-btn" @click="handleBack" :src="backButtonImage" alt="返回"/>

    <!-- 内容区域 -->
    <div class="content-box">
      <!-- 加载状态 -->
      <div v-if="loading" class="loading-state">
        <div class="loading-spinner"></div>
        <div class="loading-text">加载中...</div>
      </div>

      <!-- 饮食调养 -->
      <div v-if="servicesData && servicesData.dietaryAdvice" class="service-section diet-section">
       <div class="baige">
         <div class="bodyMass-title">气血状态
          <!-- <div class="bodyMass-div"></div> -->
        </div>
        <div class="diet-result">
          <img :src="containerImage" alt="容器" />
          <div class="diet-result-text">{{ servicesData.dietaryAdvice.constitution || '--' }}</div>
        </div>
        <div class="diet-principle">{{ servicesData.dietaryAdvice.dietaryPrinciple || '--' }}</div>

        <!-- 推荐食物 -->
        <div class="recommend-box">
          <img :src="foodIcon" alt="饮食" />
          <span>推荐食物</span>
        </div>
        <div class="recommend-message">
          <span>[蔬菜类]：<span class="gray-text">{{cleanDietaryText(servicesData.dietaryAdvice.recommendedVegetables) }}</span></span><br>
          <span>[水果类]：<span class="gray-text">{{cleanDietaryText(servicesData.dietaryAdvice.recommendedFruits)  }}</span></span><br>
          <span>[饮品类]：<span class="gray-text">{{ cleanDietaryText( servicesData.dietaryAdvice.recommendedDrinks) }}</span></span>
        </div>

        <!-- 饮食禁忌 -->
        <div class="recommend-box taboo-box">
          <img :src="tabooIcon" alt="禁忌" />
          <span class="taboo-text">饮食禁忌</span>
        </div>
        <div class="recommend-message taboo-message">
          <span>[辛辣温燥]：<span class="gray-text">{{ cleanDietaryText(servicesData.dietaryAdvice.hotFoodsToAvoid)   }}</span></span><br>
          <span>[油炸煎烤]：<span class="gray-text">{{ cleanDietaryText(servicesData.dietaryAdvice.cookingToAvoid)  }}</span></span><br>
          <span>[补品]：<span class="gray-text">{{ cleanDietaryText(servicesData.dietaryAdvice.tonicsToAvoid)  }}</span></span>
        </div>
       </div>  
      </div>

      <!-- 运动保健 -->
      <div v-if="servicesData && servicesData.exerciseRecommendations" class="service-section exercise-section">
        <div class="baige">
         <div class="bodyMass-title">运动保健
          <!-- <div class="bodyMass-div"></div> -->
        </div>
        <div class="exercise-desc">{{ servicesData.exerciseRecommendations.remark || '--' }}</div>

        <!-- 推荐运动 -->
        <div class="recommend-box">
          <img :src="runIcon" alt="饮食" />
          <span>推荐运动</span>
        </div>
        <div class="exercise-list">
          <div
            v-for="(item, index) in servicesData.exerciseRecommendations.exercises"
            :key="index"
            class="exercise-item"
          >
            {{ item }}
          </div>
        </div>
        <div class="exercise-desc exercise-note">
          运动时间避开烈日，及时补充水分(温水或凉白开，忌冰水)
        </div>
       </div> 
      </div>

      <!-- 情志起居 -->
      <div v-if="servicesData && servicesData.emotionLivingAdvice" class="service-section emotion-section">
       <div class="baige">
        <div class="bodyMass-title">情志起居
          <!-- <div class="bodyMass-div"></div> -->
        </div>

        <!-- 情志调养 -->
        <div class="recommend-box emotion-box">
          <img :src="happyIcon" alt="高兴" />
          <span class="emotion-text">情志调养</span>
        </div>
        <div class="recommend-message emotion-message" v-html="qingzhiText"></div>

        <!-- 起居调养 -->
        <div class="recommend-box living-box">
          <img :src="livingIcon" alt="起居" />
          <span class="living-text">起居调养</span>
        </div>
        <div class="recommend-message living-message" v-html="qizhuText"></div>
       </div>  
      </div>

      <!-- 艾灸按摩 -->
      <div v-if="anmoData" class="service-section massage-section">
       <div class="baige">
        <div class="bodyMass-title">艾灸按摩
          <!-- <div class="bodyMass-div"></div> -->
        </div>
        <div class="exercise-desc massage-desc">{{ anmoData.massageHealthCare.statusStatement || '--' }}</div>
        <div class="recommend-message massage-message">
          {{ anmoData.massageHealthCare?.acupointSelection || '--' }}<br>
          {{ anmoData.massageHealthCare?.method || '--' }}
        </div>
        <div
          v-for="(item, index) in anmoData.massageHealthCare?.acupoints"
          :key="index"
          class="acupoint-box"
        >
          <img class="acupoint-img" :src="item.imageUrl" alt="穴位" />
          <div class="acupoint-text">
            <div class="item-name">{{ item.name || '--' }}</div>
            <div>{{ item.position || '--' }}</div>
            <div>{{ item.findingAcupointMethod || '--' }}</div>
          </div>
        </div>
       </div>  
      </div>

      <!-- 底部间距 -->
      <div class="bottom-spacer"></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapState } from 'vuex'
import { getHealthServices } from '@/api/health'
import { getReportHome } from '@/api/report'

export default {
  name: 'HealthService',
  computed: {
    ...mapState('report', ['detectionNo'])
  },
  data() {
    return {
      loading: false,
      servicesData: null,
      anmoData: null,
      qingzhiText: '',
      qizhuText: '',
      // 图片资源 - HealthService 页面专用（使用 public 路径）
      bgImage: '/images/backgrounds/home-bg.png',
      logoImage: '/images/backgrounds/title5.png',
      backButtonImage: '/images/home/header-back@1x.png',
      containerImage: '/images/home/container-649@1x.png',
      foodIcon: '/images/health-service/food-icon@1x.png',
      runIcon: '/images/health-service/run.png',
      tabooIcon: '/images/health-service/taboo-icon@1x.png',
      happyIcon: '/images/health-service/happy-icon@1x.png',
      livingIcon: '/images/health-service/living-icon@1x.png'
    }
  },
  async created() {
    await this.loadData()
  },
  methods: {
    ...mapActions('report', ['setDetectionNo']),
    async loadData() {
      this.loading = true
      try {
        // 获取 detectionNo（从路由参数，参考 Home.vue 的方式）
        let detectionNo = this.$route.query.id || this.$route.query.detectionNo
        // let detectionNo = "3249757038638192067666576"
        if (!detectionNo) {
          const currentUrl = window.location.href
          const idMatch = currentUrl.match(/[?&]id=([^&]*)/)
          if (idMatch && idMatch[1]) {
            detectionNo = idMatch[1]
          }
        }

        // 如果还是没有获取到，尝试从store中获取
        if (!detectionNo && this.detectionNo) {
          detectionNo = this.detectionNo
        }

        if (!detectionNo) {
          console.error('缺少检测编号 id2 或 detectionNo')
          this.loading = false
          return
        }

        // 保存detectionNo到store
        this.setDetectionNo(detectionNo)

        // 并行调用两个接口
        const [servicesRes, reportRes] = await Promise.all([
          // 获取健康服务数据
          getHealthServices({ detectionNo }).catch(err => {
            console.error('Failed to load health services:', err)
            return null
          }),
          // 获取报告数据（用于艾灸按摩）
          getReportHome({ detectionNo }).catch(err => {
            console.error('Failed to load report data:', err)
            return null
          })
        ])

        // 处理健康服务数据
        if (servicesRes) {
          this.servicesData = servicesRes

          // 处理情志起居数据（将数组转换为 HTML，按照 uniapp 的方式）
          if (this.servicesData.emotionLivingAdvice) {
            if (Array.isArray(this.servicesData.emotionLivingAdvice.emotionRegulation)) {
              this.qingzhiText = this.servicesData.emotionLivingAdvice.emotionRegulation.join('<br>')
            }
            if (Array.isArray(this.servicesData.emotionLivingAdvice.livingNurturing)) {
              this.qizhuText = this.servicesData.emotionLivingAdvice.livingNurturing.join('<br>')
            }
          }
        }

        // 处理艾灸按摩数据（从 report 的 treatplanjson 解析，按照 uniapp 的方式）
        if (reportRes && reportRes.bizTongue && reportRes.bizTongue.treatplanjson) {
          try {
            this.anmoData = JSON.parse(reportRes.bizTongue.treatplanjson)
          } catch (e) {
            console.error('Failed to parse treatplanjson:', e)
          }
        }
      } catch (error) {
        console.error('Failed to load data:', error)
      } finally {
        this.loading = false
      }
    },
    cleanDietaryText(value, defaultValue = '--') {
    // 处理空值
    if (!value) return defaultValue;
    
    // 如果是数组，转换为逗号分隔的字符串
    let textValue = Array.isArray(value) ? value.join(', ') : String(value);
    
    // 移除 [] 和 "" 以及多余的空格
    return textValue.replace(/\[|\]|\"|\'/g, '').trim();
  },

    handleBack() {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
.health-service-page {
  width: 100vw;
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
}

// 背景图片
.page-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

// Logo
.page-logo {
  position: absolute;
  left: 40rpx;
  top: 50rpx;
  width: 315.6rpx;
  height: 100rpx;
  z-index: 2;
}

// 返回按钮
.page-back-btn {
  position: absolute;
  left: 495rpx;
  top: 65rpx;
  width: 220rpx;
  height: 70rpx;
  border-radius: 10rpx;
  opacity: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6rpx;
  box-sizing: border-box;
  border: 1px solid #FFFFFF;
}

// 内容区域
.content-box {
  position: absolute;
  left: 36rpx;
  top: 154rpx;
  width: 677rpx;
  z-index: 1;

  @include respond-to(mobile) {
    left: 20rpx;
    top: 160rpx;
    width: calc(100% - 40rpx);
    max-width: 800rpx;
  }
}

// 加载状态
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80rpx 40rpx;
  min-height: 400rpx;

  .loading-spinner {
    width: 80rpx;
    height: 80rpx;
    border: 8rpx solid #f3f3f3;
    border-top: 8rpx solid #5CC0FF;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  .loading-text {
    margin-top: 32rpx;
    font-size: 28rpx;
    color: #666;
  }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

// 服务模块
.service-section {
  position: relative;
  margin-top: 31.25rpx;
  width: 677rpx;
  border-radius: 20rpx;
  padding: 6rpx;
  box-sizing: border-box;
  background: rgba(175, 225, 255, 0.5);
  border: 2px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0px 2px 10px 0px rgba(42, 150, 225, 0.3);
  z-index: 2;

  @include respond-to(mobile) {
    width: 100%;
    margin-top: 20rpx;
    padding-bottom: 24rpx;
  }
}

// 模块标题
.section-title {
  position: relative;
  left: 0;
  top: 0;
  width: 177rpx;
  height: 36rpx;
  border-radius: 26rpx 26rpx 26rpx 0;
  text-align: center;
  line-height: 36rpx;
  font-size: 26rpx;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(284deg, #2397F0 22%, #94DE30 99%);

  @include respond-to(mobile) {
    width: 200rpx;
    height: 60rpx;
    line-height: 60rpx;
    font-size: 28rpx;
  }
}

// 饮食调养 - 体质结果
.diet-result {
  position: relative;
  left: 36rpx;
  margin-top: 30rpx;
  width: 583.3rpx;
  height: 100rpx;
  opacity: 1;

  img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .diet-result-text {
    position: absolute;
    top: 22.8rpx;
    width: 100%;
    text-align: center;
    height: 38.54rpx;
    font-size: 31.25rpx;
    font-weight: bold;
    color: #ffffff;

    @include respond-to(mobile) {
      font-size: 32rpx;
    }
  }
}

// 饮食原则
.diet-principle {
  position: relative;
  left: 35.875rpx;
  margin-top: 28rpx;
  width: 583.3rpx;
  height: 71.875rpx;
  border-radius: 10rpx;
  padding-left: 15.625rpx;
  line-height: 71.875rpx;
  background: #F8F8F8;
  color: #3D3D3D;
  font-size: 21rpx;

  // @include respond-to(mobile) {
  //   margin-top: 40rpx;
  //   height: auto;
  //   min-height: 60rpx;
  //   line-height: 1.5;
  //   padding: 16rpx;
  //   font-size: 24rpx;
  // }
}

// 推荐/禁忌标题盒子
.recommend-box {
  position: relative;
  left: 36rpx;
  margin-top: 28.8rpx;
  width: 187.5rpx;
  height: 42rpx;
  border-radius: 26rpx;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 5.2rpx;
  background: rgba(14, 110, 184, 0.06);
  box-sizing: border-box;
  border: 2rpx solid #5CC0FF;

  img {
    width: 31.25rpx;
    height: 31.25rpx;
  }

  span {
    font-size: 20.8rpx;
    color: #5CC0FF;

    @include respond-to(mobile) {
      font-size: 24rpx;
    }
  }

  @include respond-to(mobile) {
    width: 220rpx;
    height: 56rpx;
    gap: 8rpx;
  }
}

// 禁忌盒子
.taboo-box {
  border: 2rpx solid #FF4D4F;
  background: rgba(255, 77, 79, 0.06);

  .taboo-text {
    color: #FF4D4F;
  }
}

// 情志盒子
.emotion-box {
  border: 2rpx solid #90BB55;
  background: rgba(144, 187, 85, 0.06);

  .emotion-text {
    color: #90BB55;
  }
}

// 起居盒子
.living-box {
  border: 2rpx solid #5CC0FF;
  background: rgba(14, 110, 184, 0.06);

  .living-text {
    color: #5CC0FF;
  }
}

// 推荐/禁忌内容
.recommend-message {
  position: relative;
  left: 36rpx;
  margin-top: 15.625rpx;
  width: 583rpx;
  font-size: 20.8rpx;
  font-weight: normal;
  line-height: 1.5;
  letter-spacing: 1.5rpx;
  color: #5CC0FF;

  .gray-text {
    color: #979797;
  }

  @include respond-to(mobile) {
    width: calc(100% - 94rpx);
    font-size: 24rpx;
  }
}

// 禁忌内容
.taboo-message {
  color: #FF4D4F;
}

// 情志内容
.emotion-message {
  color: #90BB55;
}

// 起居内容
.living-message {
  color: #5CC0FF;
}

// 运动保健
.exercise-section {
  z-index: 1;
}

.exercise-desc {
  position: relative;
  left: 36rpx;
  margin-top: 38rpx;
  width: 583rpx;
  min-height: 102rpx;
  padding: 20.8rpx 15.625rpx;
  background: #F8F8F8;
  font-size: 20.8rpx;
  font-weight: normal;
  line-height: 1.5;
  color: #3D3D3D;
  border-radius: 18rpx;
  // @include respond-to(mobile) {
  //   width: calc(100% - 94rpx);
  //   font-size: 24rpx;
  //   min-height: 80rpx;
  //   padding: 24rpx 20rpx;
  // }
}

.exercise-note {
  height: 71.875rpx;

  @include respond-to(mobile) {
    height: auto;
    min-height: 60rpx;
  }
}

// 运动列表
.exercise-list {
  position: relative;
  left: 36rpx;
  margin-top: 20.8rpx;
  width: 583rpx;
  height: 40.625rpx;
  display: flex;
  flex-direction: row;
  // gap: 31.25rpx;
  flex-wrap: wrap;

  @include respond-to(mobile) {
    width: calc(100% - 94rpx);
    height: auto;
    gap: 20rpx;
  }
}

.exercise-item {
  height: 40.625rpx;
  border-radius: 5.2rpx;
  padding: 6.5rpx;
  font-size: 20.8rpx;
  margin-right: 31.25rpx;
  color: #5CC0FF;
  background: rgba(14, 110, 184, 0.06);
  box-sizing: border-box;
  border: 2rpx solid #5CC0FF;
  display: flex;
  align-items: center;
  white-space: nowrap;

  @include respond-to(mobile) {
    height: auto;
    min-height: 48rpx;
    padding: 8rpx 16rpx;
    font-size: 24rpx;
  }
}

// 情志起居
.emotion-section {
  z-index: 2;
  padding-bottom: 6.458rpx;
}

// 艾灸按摩
.massage-section {
  z-index: 3;
}

.massage-desc {
  height: auto;
}

.massage-message {
  height: 90.625rpx;
  color: #5CC0FF;
  overflow-y: scroll;
  @include respond-to(mobile) {
    height: auto;
    min-height: 80rpx;
  }
}

// 穴位盒子
.acupoint-box {
  position: relative;
  left: 36rpx;
  margin-top: 20.8rpx;
  width: 583rpx;
  height: 188rpx;
  border-radius: 10.4rpx;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10.4rpx;
  gap: 15.625rpx;
  background: #F8F8F8;
  z-index: 2;

  @include respond-to(mobile) {
    width: calc(100% - 94rpx);
    height: auto;
    min-height: 160rpx;
    padding: 16rpx;
    gap: 20rpx;
  }
}

.acupoint-img {
  position: absolute;
  left: 10.4rpx;
  top: 16.14rpx;
  width: 156.25rpx;
  height: 156.25rpx;
  border-radius: 10.4rpx;
  box-sizing: border-box;
  border: 2rpx solid #FFFFFF;
  z-index: 0;

  @include respond-to(mobile) {
    position: relative;
    left: auto;
    top: auto;
    width: 120rpx;
    height: 120rpx;
    flex-shrink: 0;
  }
}

.acupoint-text {
  position: relative;
  left: 182rpx;
  height: 147.7rpx;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding: 0;
  gap: 8.3rpx;
  flex-grow: 1;
  z-index: 1;

  @include respond-to(mobile) {
    left: auto;
    height: auto;
    gap: 12rpx;
  }

  div {
    width: 390.625rpx;
    line-height: 1.5;
    letter-spacing: 1.5rpx;
    color: #3D3D3D;
    font-size: 20.8rpx;

    @include respond-to(mobile) {
      width: 100%;
      font-size: 24rpx;
    }
  }

  .item-name{
    color: #5CC0FF;
    font-size:  28rpx;
  }

  &::-webkit-scrollbar {
    width: 4rpx;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 2rpx;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 2rpx;

    &:hover {
      background: #555;
    }
  }
}

// 底部间距
.bottom-spacer {
  height: 50rpx;
  position: relative;

  @include respond-to(mobile) {
    height: 40rpx;
  }
}
.bodyMass-title {
  position: relative;
  left: 18.7rpx;
  top: 18.7rpx;    
  // height: 52px;
  opacity: 1;
  font-family: Source Han Sans;
  font-size: 33.6rpx;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3D3D3D;
  z-index: 6;
}

.bodyMass-div{
  position: absolute;
  left: 0px;
  top: 30.7rpx;
width: 140rpx;
height: 9.34rpx;
z-index: -1;
/* 主色 */
background: linear-gradient(270deg, #3D8AFE 0%, #5CC0FF 100%);
	
}
.baige{
  width: 654rpx;
  background-color: #fff;
  border-radius: 20rpx;
  padding-bottom: 30rpx;
}
</style>
